import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faFacebook, faInstagram, faTwitter, faDiscord, faGitlab } from '@fortawesome/free-brands-svg-icons';
import '../styles/contact.css'; // Import the CSS for styling

const Contact = () => {
    // Define the social media platforms and links in a constant
    const socialLinks = [
        {
            name: 'LinkedIn',
            url: 'https://www.linkedin.com/in/bipinnepal',
            icon: faLinkedin,
            iconClass: 'linkedin'
        },
        {
            name: 'Gitlab',
            url: 'https://gitlab.com/bipinnepal43',
            icon: faGitlab,
            iconClass: 'gitlab'
        },
        {
            name: 'Facebook',
            url: 'https://www.facebook.com/RestlesSoul13',
            icon: faFacebook,
            iconClass: 'facebook'
        },
        {
            name: 'Instagram',
            url: 'https://www.instagram.com/bipin_n13',
            icon: faInstagram,
            iconClass: 'instagram'
        },
        {
            name: 'Twitter',
            url: 'https://twitter.com/bpnnepal',
            icon: faTwitter,
            iconClass: 'twitter'
        },
        {
            name: 'Discord',
            url: 'https://discord.com/users/bipinnepal43',
            icon: faDiscord,
            iconClass: 'discord'
        }
    ];

    return (
        <div className="contact">
            <div className="social-links">
                {/* Loop through the socialLinks array to generate the social media links */}
                {socialLinks.map((platform, index) => (
                    <a
                        key={index}
                        href={platform.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`social-icon ${platform.iconClass}`}
                    >
                        <FontAwesomeIcon icon={platform.icon} size="2x" />
                        <span className="social-name">{platform.name}</span>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default Contact;
